import { defineComponent, KeepAlive, provide } from "vue"
import { RouterView } from "vue-router"
import { useAppStore, useInfoStore } from "@/store"
import { ConfigProvider } from "ant-design-vue"
import zhCN from "ant-design-vue/es/locale/zh_CN"
import "./reset.css"
import "@/style/index.less"
import "@/style/ui-elder.less"
import "@/style/ui-normal.less"

export default defineComponent({
  name: "App",
  props: {},
  setup() {
    /** 枚举初始化 */
    const infoStore = useInfoStore()
    infoStore.getAllEnums()
    infoStore.getCommonAres()

    provide("enumsStore", useInfoStore)
    const appStore = useAppStore()

    const slots = {
      default: ({ Component }) => {
        return (
          <KeepAlive include={appStore.cachedViews} max={10}>
            {Component && <Component />}
          </KeepAlive>
        )
      }
    }

    return () => (
      <ConfigProvider locale={zhCN}>
        <RouterView vSlots={slots} />
      </ConfigProvider>
    )
  }
})
